import { Component } from '@angular/core';
// import { HttpClient } from "@angular/common/http";
import { IonicPage, Loading, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Items, User } from '../../providers/providers';

//declare var Stripe: any;

@IonicPage({
  name: 'payment-details',
  segment: 'payment-details',
})
@Component({
  selector: 'page-payment-details',
  templateUrl: 'payment-details.html',
})
export class PaymentDetailsPage {
  //stripe = Stripe("pk_live_7CMAfpsDQwbZZ7QqAxWxHB41");
  card: any;
  clientId: string = this.navParams.get('clientId');
  plan: string = this.navParams.get('plan');
  credentials: any = this.navParams.get('credentials');
  price: string = this.navParams.get('price');
  duration: string = this.navParams.get('duration');
  responseData: any;

  constructor(public navParams: NavParams, public items: Items, public user: User, public navCtrl: NavController, public toastCtrl: ToastController, public loading: LoadingController) {
  }

  // ngOnInit() {
  //   this.setupStripe();
  // }
  // ionViewWillEnter(){
  //   this.setupStripe();
  // }

  // setupStripe() {
  //   let elements = this.stripe.elements();
  //   var style = {
  //     base: {
  //       iconColor: '#c4f0ff',
  //       color: '#32325d',
  //       lineHeight: '24px',
  //       width: '30em',
  //       fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
  //       fontSmoothing: 'antialiased',
  //       fontSize: '16px',
  //       '::placeholder': {
  //         color: '#aab7c4'
  //       }
  //     },
  //     invalid: {
  //       color: '#fa755a',
  //       iconColor: '#fa755a'
  //     }
  //   };

  //   this.card = elements.create('card', { iconStyle: 'solid', style: style });
  //   // console.log(this.card);
  //   this.card.mount('#card-element');

  //   this.card.addEventListener('change', event => {
  //     var displayError = document.getElementById('card-errors');
  //     if (event.error) {
  //       displayError.textContent = event.error.message;
  //     } else {
  //       displayError.textContent = '';
  //     }
  //   });

  //   var form = document.getElementById('payment-form');
  //   form.addEventListener('submit', event => {
  //     event.preventDefault();
  //     let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 7000, dismissOnPageChange: true, cssClass: 'activity-detail-loading', showBackdrop: false });
  //     loading.present();
  //     this.stripe.createToken(this.card).then(result => {
  //       if (result.error) {
  //         var errorElement = document.getElementById('card-errors');
  //         errorElement.textContent = result.error.message;
  //       } else {
  //         let body: any;
  //         body = { token: result.token.id, plan: this.plan }
  //         localStorage.setItem('userId', this.credentials.username);
  //         localStorage.setItem('password', this.credentials.password);
  //         this.items.planSignup(body, this.clientId).subscribe(
  //           data => {
  //             this.doLogin(loading)
  //           },
  //           err => {
  //             loading.dismissAll();
	//       this.presentToast("There was a problem with the payment");
  //             console.log(err);
  //           },

  //         );
  //       }
  //     });
  //   });
  // }

  // doLogin(loading: Loading) {
  //   if (this.credentials.username && this.credentials.password) {
  //     // let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 4000, dismissOnPageChange: true, cssClass: 'activity-detail-loading', showBackdrop: false });
  //     // loading.present();
  //     this.user.login(this.credentials).then((result) => {
  //       this.responseData = result;
  //       if (this.responseData.meta.status = 'ok') {
  //         loading.dismissAll();
  //         localStorage.setItem('userData', JSON.stringify(this.responseData.data.user));
  //         localStorage.setItem('userId', this.credentials.username);
  //         localStorage.setItem('password', this.credentials.password);
  //         this.navCtrl.push('home');
  //       }
  //       else {
  //         loading.dismissAll();
  //         this.presentToast("Unable to sign in. Please check your account information and try again.");
  //       }
  //     }, (err) => {
  //       loading.dismissAll();
  //       this.presentToast("Unable to sign in. Please check your account information and try again.");
  //     });
  //   }
  //   else {
  //     this.presentToast("Give username and password");
  //   }
  // }

  // presentToast(msg) {
  //   let toast = this.toastCtrl.create({
  //     message: msg,
  //     duration: 5000,
  //     position: 'top'
  //   });
  //   toast.present();
  // }

  // openPricing() {
  //   window.open("https://novopsych.com/pricing/", "_blank", "location=true");
  // }

}


// WEBPACK FOOTER //
// ./src/pages/payment-details/payment-details.ts